export default __webpack_public_path__ + "3a4a6e4f1738ffe514b8b6f31bceeb18.svg";